import { get } from "lodash-es";
import { fitDataIdKey } from "../../fitData/consts";
import { getMethodSchemas } from "./getMethodSchemas";
const stateSystemMethods = [{
  id: 'waitForReady',
  title: '等待数据源就绪',
  description: '数据源就绪后，才能调用数据源方法。\
      \n\n这是一个异步函数，使用时在前面加上 await 才能用！\
      \n\n例子：`await data.xxxxx.waitForReady();`',
  arguments: [],
  isAsync: true
}];
export function setStateSchema() {
  var _this$options$sourceC;
  const meta = this.stateMeta;
  const customFields = (_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.fields;
  const {
    stateSchema
  } = this;
  const fields = Object.entries(meta.stateSchemas).map(([prop, schema]) => {
    const customSchema = customFields === null || customFields === void 0 ? void 0 : customFields.find(item => item.id === prop);
    if (customSchema) {
      return customSchema;
    }
    if (typeof schema === 'function') {
      return schema.apply(this);
    }
    return schema;
  }).filter(Boolean);
  if (this.isJSStateModel) {
    fields === null || fields === void 0 ? void 0 : fields.push({
      id: 'loading',
      type: 'boolean',
      title: 'loading状态',
      hidden: true
    });
  }
  fields === null || fields === void 0 ? void 0 : fields.push({
    id: 'isReady',
    type: 'boolean',
    title: '数据源是否已就绪',
    hidden: true
  });
  if (this.customStateSchema) {
    fields === null || fields === void 0 ? void 0 : fields.push(this.customStateSchema);
  }
  fields.push(this.$requestsSchema);
  const methods = getMethodSchemas(this.actionSchema);
  if (methods) {
    stateSchema.methods = [...methods, ...stateSystemMethods];
  } else {
    stateSchema.methods = stateSystemMethods;
  }
  if (this.isJSStateModel && get(this, 'fitDataId')) {
    stateSchema[fitDataIdKey] = get(this, 'fitDataId');
  }
  stateSchema.fields = fields.concat(stateSchema.fields || []);
  stateSchema['uc:collapsed'] = true;
  // return stateSchema;
}
/**
 * 实时更新 stateSchema
 * @param state
 * @param prop
 * @returns
 */
export function updateStateSchema(state, prop) {
  var _state$options$source;
  const customFields = (_state$options$source = state.options.sourceConfig) === null || _state$options$source === void 0 ? void 0 : _state$options$source.fields;
  let newSchema = (customFields === null || customFields === void 0 ? void 0 : customFields.find(item => item.id === prop)) || null;
  if (!newSchema) {
    const info = state.stateMeta.stateSchemas[prop];
    newSchema = typeof info === 'function' ? info.apply(state) : info;
  }
  if (!newSchema) return false;
  const schemaIndex = (state.stateSchema.fields || []).findIndex(item => item.id === prop);
  if (schemaIndex > -1) {
    var _state$stateSchema$fi;
    (_state$stateSchema$fi = state.stateSchema.fields) === null || _state$stateSchema$fi === void 0 ? void 0 : _state$stateSchema$fi.splice(schemaIndex, 1, newSchema);
  }
  return true;
}
//# sourceMappingURL=setStateSchema.js.map
